export const Logo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 36" height="36">
    <defs>
      <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FF6600" />
        <stop offset="100%" stopColor="#FF0077" />
      </linearGradient>
    </defs>
    <rect
      x="0"
      y="0"
      width="200"
      height="36"
      rx="18"
      fill="url(#gradient)"
      style={{ boxShadow: "0 2px 4px rgba(0,0,0,0.25)" }}
    />
    <text
      x="10"
      y="24"
      fill="#fff"
      fontFamily="Helvetica Neue,Helvetica,Arial,sans-serif"
      fontSize="22"
      fontWeight="bold"
    >
      Youniverse.game
    </text>
  </svg>
);
